import { ComponentPropsWithoutRef, FC, useState } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export interface ITabCard {
  tabName: string
  tabNum: number
  isSelected: boolean
  setSelected: () => void
}

const TabCard: FC<ITabCard> = ({ tabName, tabNum, isSelected, setSelected }) => {
  const commonProps: ComponentPropsWithoutRef<typeof Box> = {
    alignItems: 'stretch',
    justifyContent: 'center',
    textAlign: 'center',
    padding: 's4',
    style: {
      flex: '1',
    },
  } as const

  if (isSelected) {
    return (
      <Box {...commonProps} position="relative">
        <Box.Motion
          borderRadius={{ all: 'abs100' }}
          position="absolute"
          layout
          layoutId="tab"
          background="grey000White"
          boxShadow="s50"
          style={{
            zIndex: '0',
            top: '4px',
            left: '4px',
            bottom: '4px',
            right: '4px',
          }}
        />
        <Box style={{ zIndex: '1' }} paddingX="s24" paddingY="s4">
          <Text.Normal size="200" weight="semibold">
            {tabNum}. {tabName}
          </Text.Normal>
        </Box>
      </Box>
    )
  }

  const TabContent: FC = () => (
    <Box padding="s4" flexGrow>
      <Text.Normal size="200" weight="normal">
        {tabNum}. {tabName}
      </Text.Normal>
    </Box>
  )

  return (
    <Box
      cursor="default"
      paddingX="s24"
      paddingY="s4"
      aria-current="step"
      {...commonProps}
      onClick={() => setSelected()}
    >
      <TabContent />
    </Box>
  )
}

interface Props {
  selectedStep: number
}

const ImportSummaryNavigationTabs = ({ selectedStep }: Props) => {
  const [currentStep, _setCurrentStep] = useState<number>(selectedStep || 0)

  return (
    <Box
      alignSelf="center"
      width="full"
      maxWidth="widePage"
      background="grey200"
      borderRadius={{ all: 'abs100' }}
      gap="s2"
      flexDirection="row"
    >
      <TabCard
        key={0}
        tabName={i18n.t('payroll_bundle.payroll_summary_import.wizard.select_data_step.title')}
        tabNum={1}
        isSelected={currentStep === 0}
        setSelected={() => {}}
      />

      <TabCard
        key={1}
        tabName={i18n.t('payroll_bundle.payroll_summary_import.wizard.map_to_concepts_step.title')}
        tabNum={2}
        isSelected={currentStep === 1}
        setSelected={() => {}}
      />

      <TabCard
        key={2}
        tabName={i18n.t(
          'payroll_bundle.payroll_summary_import.wizard.review_and_import_step.title'
        )}
        tabNum={3}
        isSelected={currentStep === 2}
        setSelected={() => {}}
      />
    </Box>
  )
}

export default ImportSummaryNavigationTabs
